export { default as Ribbon } from "./Ribbon";
